<template>
  <div class="icomposite-page">
    <screen-panel :isExpand="isOpen" class="panel">
      <ScreenBoxClick title="冷库实时库存 (单位：吨)" height="30%" menuCode="120101">
        <ColdStorageUse></ColdStorageUse>
      </ScreenBoxClick>
      <ScreenBoxClick title="冷库温度变化趋势" height="35%" menuCode="110102">
        <ColdStorageTemperature></ColdStorageTemperature>
      </ScreenBoxClick>
      <ScreenBoxClick title="穿堂平均温度变化趋势" height="35%" menuCode="110102">
        <HallwayTemperLeft></HallwayTemperLeft>
      </ScreenBoxClick>
    </screen-panel>

    <screen-panel :isExpand="isOpen" position="right" class="panel">
      <ScreenBoxClick title="冷库实时库存 (单位：吨)" height="30%" menuCode="120101">
        <ColdStorageUseRight></ColdStorageUseRight>
      </ScreenBoxClick>
      <ScreenBoxClick title="冷库温度变化趋势" height="35%" menuCode="110102">
        <ColdStorageTemRight></ColdStorageTemRight>
      </ScreenBoxClick>
      <ScreenBoxClick title="穿堂平均温度变化趋势" height="35%" menuCode="110102">
        <HallwayTemperRight></HallwayTemperRight>
      </ScreenBoxClick>
    </screen-panel>
  </div>
</template>

<script>
import screenPanel from "../components/ScreenPanel.vue";
import ScreenBoxClick from "../components/ScreenBoxClick.vue";
import ColdStorageUse from "../components/ColdStorageUse.vue";
import ColdStorageUseRight from "../components/ColdStorageUseRight.vue";
import ColdStorageTemperature from "../components/ColdStorageTemperature.vue";
import ColdStorageTemRight from "../components/ColdStorageTemRight.vue";
import HallwayTemperLeft from "../components/HallwayTemperLeft.vue";
import HallwayTemperRight from "../components/HallwayTemperRight.vue";
export default {
  data() {
    return {
      isOpen: false,
    };
  },
  components: {
    screenPanel,
    ScreenBoxClick,
    ColdStorageUse,
    ColdStorageUseRight,
    ColdStorageTemperature,
    ColdStorageTemRight,
    HallwayTemperLeft,
    HallwayTemperRight
  },
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.$map.showMap2D();
    this.isOpen = true;
  }
}
</script>

<style lang='scss' scoped>
.panel {
  height: 100%;
}
</style>